/**
 * A walkthrough step carries one of two kinds of value in `path`:
 *  - an element help-path: a slash-separated hierarchy of id segments
 *    (e.g. `timekeeping-page/header__title`) that HelpAnchorDirective computes
 *    and that NEVER begins with "/", or
 *  - a route: an absolute Angular URL (e.g. `/timekeeping/timekeeping-page`)
 *    used by cross-page tours to move the user to the next page.
 *
 * The leading slash is the discriminator: a path that starts with "/" is a
 * navigation step, everything else is an element step. The player navigates on
 * a nav step and highlights an element on an element step.
 *
 * This convention is load-bearing for cross-page walkthroughs. A regression that
 * normalized element help-paths to a leading "/" would silently reclassify every
 * element step as a (failing) navigation, so the rule lives in one tested place
 * rather than as an inline `path.startsWith('/')` scattered through the player.
 */
export function isNavStepPath(path: string | null | undefined): boolean {
  return !!path && path.startsWith('/');
}
